<template>
  <el-row>
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-input
          clearable
          v-model="keyword"
          @input="searchHandle"
          placeholder="搜索关键字(姓名、手机号)"
          prefix-icon="el-icon-search"
          style="width:300px">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="partnerId"
          placeholder="选择机构"
          @change="searchHandle"
          clearable
          style="width:140px">
          <el-option
            v-for="(item,index) in partnerList"
            :key="index"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="searchHandle">搜索</el-button>
        <!-- <el-button type="primary" icon="el-icon-download">导出</el-button> -->
      </el-form-item>
    </el-form>
    <el-button-group>
      <el-button icon="el-icon-plus" size="small">添加到</el-button>
      <el-button icon="el-icon-message" size="small">通知</el-button>
      <el-button icon="el-icon-star-off" size="small">标记</el-button>
    </el-button-group>
    <table-component
      :table-data="tableData"
      :page="page"
      :total="total"
      :size="per_page"
      @current-change="currentPageChange"
      @selection-change="selectionChange"
      :contextmenu="tableContextMenu()">
    </table-component>

      <el-dialog
      title="设置"
      :visible.sync="isShowPath"
      width="700px"
      append-to-body>
      <div>
        {{path}}
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowPath = false">取 消</el-button>
        <el-button type="primary" @click="isShowPath = false">确定</el-button>
      </span>
  </el-dialog>


  <el-dialog
      title="设置"
      :visible.sync="isShowSetting"
      width="700px"
      append-to-body>
      <el-form ref="form" :model="setting" label-width="80px" @submit.native.prevent>
        <el-form-item label="手机号" prop="title">
          <el-input v-model="setting.phone" style="width:380px;" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="title">
          <el-input v-model="setting.email" style="width:380px;" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="title 1" prop="title">
          <el-input v-model="setting.vip_title_1" style="width:380px;" placeholder="如：艺术总监"></el-input>
        </el-form-item>
        <el-form-item label="title 2" prop="title">
          <el-input v-model="setting.vip_title_2" style="width:380px;" placeholder="如: 艺术总监"></el-input>
        </el-form-item>
        <el-form-item label="他的同事" prop="title">
          <el-select
            v-model="setting.friend_ids"
            placeholder="请选择"
            clearable
            multiple
            style="width:400px">
            <el-option
              v-for="(item,index) in userList"
              :key="index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowSetting = false">取 消</el-button>
        <el-button type="primary" @click="submitSetting">保存</el-button>
      </span>
  </el-dialog>


  <el-dialog title="设置VIP会员" :visible.sync="dialogVisible" width="800px">
      <el-form ref="form" :model="form" label-width="90px">
        <partnerVips @close="closeDialog" :uuid="current.uuid"></partnerVips>
      </el-form>
  </el-dialog>

  </el-row>

</template>
<script>
import TableComponent from '@/components/Table'
import partnerVips from "@/components/partnerVips"
import request from '@/utils/request'
export default {
  name: 'UserList',
  data () {
    return {
      page: 1,
      total: 0,
      userList: [],
      per_page: 15,
      keyword: '',
      level: '',
      userGroup: [],
      setting: {},
      isShowSetting: false,
      isShowPath: false,
      path: '',
      partnerList: [],
      currentUser: {},
      partnerId: null,
      dialogVisible: false,
      form: {},
      current: {}
    }
  },
  components: {
    TableComponent,
    partnerVips
  },
  mounted () {
    let _this = this
    // 获取用户分组
    request({
      url: 'user-levels',
      method: 'get'
    }).then(res => {
      let arr = res.data.levels
      arr.unshift({
        level: '',
        name: '所有会员'
      })
      _this.userGroup = arr
    })
    this.getUserList()
    this.getPartnerList()
  },
  methods: {
    closeDialog () {
      this.dialogVisible = false
      this.getUserList()
    },
    saveChange () {
      request({
        url: `users/${this.current.uuid}`,
        method: 'PATCH',
        data: {
          type: 'update', 
          attributes: this.form
        }
      }).then(res => {
        this.$message.success('设置成功!')
        this.getUserList()
        this.dialogVisible = false
      })
    },
    // page 变化
    currentPageChange (page) {
      this.page = page
      this.getUserList()
    },
    // 获取用户列表
    getUserList () {
      let sendData = {
        per_page: this.per_page,
        page: this.page,
        key: this.keyword,
        // level: this.level,
        partner_id: this.partnerId
      }
      let _this = this
      request({
        url: 'partner-vip-users',
        method: 'get',
        params: sendData
      }).then(res => {
        // console.log(res)
        _this.total = res.data.item_total
        _this.userList = res.data.list
      })
    },
    // 获取机构列表
    getPartnerList () {
      request({
        url: '/partners',
      }).then(res => {
        this.partnerList = res.data.list
        this.partnerList.unshift({
          'id': null,
          'title': '所有机构'
        })
      })
    },
    // admin 选择用户 -- checkbox 变化
    selectionChange (list) {
      console.log(list)
    },
    // 搜索
    searchHandle () {
      this.page = 1
      this.getUserList()
    },
    tableContextCallback (item, type) {
      // console.log(item, type)
      switch (type) {
        case 'detail':
          this.$userLayer.show(item)
          break
      }
    },
    submitSetting () {
      request({
        url: 'users/' + this.currentUser.uuid,
        method: 'PATCH',
        data: {
          type: 'update',
          attributes: this.setting
        }
      }).then(res => {
        // console.log(res)
        this.isShowSetting = false
        this.$message.success('保存成功!')
        this.getUserList()
      })
    },
    // table列表右键菜单
    tableContextMenu () {
      return {
        data: '',
        callback: this.tableContextCallback,
        menulist: [
          {
            label: '详情信息',
            type: 'detail'
          },
          {
            label: '删除',
            type: 'delete'
          }
        ]
      }
    }
  },
  computed: {
    tableData: function () {
      let _this = this
      return {
        props: [
          {
            label: '头像',
            type: 'img',
            prop: 'headimg',
            width: '60'
          },
          {
            label: '名称',
            type: 'string',
            prop: 'name',
            width: '150',
            clicked (item) {
              _this.$userLayer.show(item)
            },
            style: {
              color: '#409EFF',
              cursor: 'pointer'
            }
          },
          {
            label: '性别',
            type: 'string',
            prop: 'gender',
            width: '50'
          },
          {
            label: '城市',
            type: 'string',
            width: '80',
            prop: 'city'
          },
          {
            label: '手机号',
            type: 'string',
            width: '130',
            prop: 'phone'
          },
          // {
          //   label: '积分',
          //   type: 'string',
          //   width: '150',
          //   prop: 'score'
          // },
          {
            label: '所属机构',
            type: 'string',
            width: '200',
            // prop: 'level_text',
            change: (row) => {
              let str = []
              for (var i = row.partner_vips.length - 1; i >= 0; i--) {
                let item = row.partner_vips[i].partner
                str.push(item.title)
              }
              return str.join('、')
            }
          },
          // {
          //   label: 'VIP起始',
          //   type: 'simple_time',
          //   width: '100',
          //   // prop: 'vip_start_at',
          //   change: (row) => {
          //     return row.vip_start_at.substr(0, 10)
          //   }
          // },
          // {
          //   label: 'VIP结束',
          //   type: 'simple_time',
          //   width: '100',
          //   // prop: 'vip_end_at',
          //   change: (row) => {
          //     return row.vip_end_at.substr(0, 10)
          //   }
          // },
          {
            label: '活跃于',
            type: 'time_day',
            prop: 'last_active_at'
          },
          {
            label: '操作',
            // type: 'time_day',
            // prop: 'last_active_at'
            change: (res) => {
               return '设置机构会员'
            },
            clicked: (item) => {
              this.current = item

              this.form = {
                level: item.level,
                vip_start_at: item.vip_start_at,
                vip_end_at: item.vip_end_at
              }
              this.dialogVisible = true
              return false


              this.currentUser = item

              console.log(item)

              this.setting = {
                vip_title_1: item.vip_title_1,
                vip_title_2: item.vip_title_2,
                friend_ids: item.friend_ids || [],
                phone: item.phone,
                email: item.email
              }
              this.isShowSetting = true
            },
            style: {
              color: '#409EFF',
              cursor: 'pointer'
            }
          },
          // {
          //   label: '路径',
          //   // type: 'time_day',
          //   // prop: 'last_active_at'
          //   change: (res) => {
          //      return '小程序路径'
          //   },
          //   clicked: (item) => {
          //     this.path = '/pages/vip/index?uuid=' + item.uuid
          //     this.isShowPath = true
          //   },
          //   style: {
          //     color: '#409EFF',
          //     cursor: 'pointer'
          //   }
          // }
        ],
        list: this.userList,
        selection: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/partnerVip/list.vue